/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Input, Button } from '../../components';
import { insereDados } from '../../store/actions/questionario-actions';

function Main(props) {
  const onChange = (event) => {
    const { name, value } = event.target;
    props.insereDados(name, value);
  };
  const [valid, setValid] = useState({});
  const schema = Yup.object().shape({
    tipo: Yup.string()
      .min(2, 'Esse campo é obrigatório.')
      .required('Esse campo é obrigatório.'),
  });
  const goProximaQuestao = (e) => {
    e.preventDefault();
    const dados = {
      tipo: props.dados.tipo,
    };
    schema.validate(dados).then(
      () => {
        props.history.push(props.dados.tipo === 'anonima' ? '/questao22' : '/questao21');
      },
    ).catch((err) => {
      setValid(err);
    });
  };
  return (
    <form schema={schema} onSubmit={goProximaQuestao} noValidate>
      <h3> 1 -Você quer se identificar ou registrar uma denúncia anônima? </h3>
      <Input
        type="radio"
        name="tipo"
        value="identificada"
        checked={props.dados.tipo === 'identificada'}
        onChange={onChange}
      />

      <span>Quero me identificar.</span>
      <br />
      <Input
        type="radio"
        name="tipo"
        value="anonima"
        checked={props.dados.tipo === 'anonima'}
        onChange={onChange}
      />
      <span>Quero registrar denúncia anônima.</span>
      <br />
      <span className="worning">{valid.errors && valid.errors[0]}</span><br />
      <Button
        type="submit"
        className="button"
      >PRÓXIMA QUESTÃO
      </Button>
    </form>
  );
}
const mapStateToProps = state => (
  {
    dados: state.QuestionarioReducers,
  }
);
export default connect(mapStateToProps, { insereDados })(Main);
